import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MyFeaturesComponent } from './my-features.component';
import { MyFeaturesListComponent } from './components/my-features-list.component';

import { AppSharedModule } from './../shared/appShared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DatePickerModule } from 'primeng/datepicker';
import { EditorModule } from 'primeng/editor';
import { ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
@NgModule({ declarations: [MyFeaturesListComponent, MyFeaturesComponent],
    imports: [
        BrowserModule,
        RouterModule,
        FormsModule,
        DatePickerModule,
        EditorModule,
        ReactiveFormsModule,
        ContextMenuModule,
        MenuModule,
        ConfirmDialogModule,
        AppSharedModule
    ], providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class MyFeaturesModule {}
